import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
const ConfirmAction = (title, message, callback) => {
    return new Promise((resolve, reject) => {
        confirmAlert({
            title,
            message,
            buttons: [
                {
                    label: "Yes",
                    onClick: () => {
                        callback && callback();
                        resolve(true);
                    },
                },
                {
                    label: "No",
                    onClick: () => resolve(false),
                },
            ],
            overlayClassName: "overlay-custom-class-name",
            customUI: ({ onClose }) => (_jsxs("div", Object.assign({ className: "bg-white shadow-md border max-w p-4 rounded-lg " }, { children: [_jsx("h1", Object.assign({ className: "mb-6 text-lg" }, { children: title })), _jsx("p", Object.assign({ className: "mb-3 mt-2" }, { children: message })), _jsxs("div", Object.assign({ className: "flex justify-center" }, { children: [_jsx("button", Object.assign({ className: "bg-black mr-4 w-24 opacity-90 hover:opacity-100 cursor-pointer text-white px-4 py-1 rounded-md", onClick: () => {
                                    callback && callback();
                                    onClose();
                                    resolve(true);
                                } }, { children: "Yes" })), _jsx("button", Object.assign({ className: "bg-black w-24 opacity-90 hover:opacity-100 cursor-pointer text-white px-4 py-1 rounded-md", onClick: () => onClose() }, { children: "Cancel" }))] }))] }))),
        });
    });
};
export default ConfirmAction;
